import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

// This is where you can change the bot logo image
const logoImage = '/logoImage.png'; // Using the image from public directory

const Hero = () => {
  const isMobile = useIsMobile();
  
  return (
    <section className="relative pt-20 pb-32 overflow-hidden bg-gradient-to-b from-white to-pink-50 dark:from-gray-800 dark:to-gray-900">
      <div className="container-custom relative z-10">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in dark:text-white">
              Meet <span className="text-fembot-pink relative inline-block">Fembot</span>, your server's new best friend
            </h1>
            <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-lg animate-fade-in" style={{animationDelay: '0.1s'}}>
              A powerful, feature-rich Discord bot that enhances your server with moderation tools, AI capabilities, and security features.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 animate-fade-in" style={{animationDelay: '0.2s'}}>
              <Button 
                className="btn-primary flex items-center gap-2"
                onClick={() => window.location.href = "/info"}
              >
                Add to Discord <ArrowRight size={18} />
              </Button>
              <Button 
                variant="outline" 
                className="btn-outline"
                onClick={() => window.location.href = '/premium'}
              >
                Go Premium
              </Button>
            </div>
          </div>
          <div className="md:w-1/2">
            <div className="relative w-full max-w-md mx-auto animate-float">
              {/* Adjusted sizing for mobile vs desktop */}
              <div className={`aspect-square rounded-full bg-fembot-light-pink/30 ${isMobile ? 'p-3' : 'p-6'}`}>
                <div className={`w-full h-full rounded-full bg-fembot-light-pink/50 ${isMobile ? 'p-2' : 'p-5'}`}>
                  <div className={`w-full h-full rounded-full bg-fembot-pink/30 ${isMobile ? 'p-1.5' : 'p-4'} animate-pulse-glow`}>
                    <div className="w-full h-full rounded-full bg-gradient-to-br from-fembot-pink to-fembot-light-pink flex items-center justify-center overflow-hidden">
                      {logoImage ? (
                        <img 
                          src={logoImage} 
                          alt="Bot Avatar" 
                          className="w-full h-full object-cover rounded-full"
                        />
                      ) : (
                        <span className={`${isMobile ? 'text-6xl' : 'text-4xl md:text-8xl'} font-bold text-white`}>F</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-16 bg-wave-pattern opacity-50"></div>
    </section>
  );
};

export default Hero;
